import React from "react";
import SvgStart from "../svg/SvgStart";

const HowItWorks = ({createUserClients, createUserProfesional}) => {
  return (
    <section
      id="how-it-works"
      className=" py-16 md:py-24"
    >
      <div className="max-w-6xl mx-auto px-6 text-center">
        <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-10">
          Cómo funciona nuestra plataforma
        </h2>
        <p className="text-gray-600 text-lg md:text-xl mb-12">
          Tanto si eres padre buscando una niñera o una niñera buscando oportunidades,
          nuestro sistema es sencillo y eficiente.
        </p>

        <div className="grid md:grid-cols-2 gap-12">
          {/* Proceso para Niñeras */}
          <div
            className="group p-6 bg-white rounded-lg shadow-lg hover:shadow-2xl transition-shadow duration-300"
            onClick={createUserProfesional}
          >
            <h3 className="text-2xl font-bold text-blue-500 mb-4 group-hover:scale-105 transition-transform">
              Para Niñeras
            </h3>
            <ul className="space-y-4 text-gray-700 text-left">
              <li className="flex items-start gap-4">
                <span className="flex-shrink-0 w-8 h-8 bg-blue-500 text-white rounded-full flex items-center justify-center text-lg font-bold group-hover:scale-110 transition-transform">
                  <SvgStart />
                </span>
                <span>Completa el proceso de registro en la plataforma Niñeras YA para comenzar a ofrecer tus servicios como niñera.</span>
              </li>
              <li className="flex items-start gap-4">
                <span className="flex-shrink-0 w-8 h-8 bg-blue-500 text-white rounded-full flex items-center justify-center text-lg font-bold group-hover:scale-110 transition-transform">
                <SvgStart />
                  
                </span>
                <span>Incluye tu nombre completo, edad, y una breve descripción sobre ti, enfocada en tus habilidades y pasión por el cuidado infantil.</span>
              </li>
              <li className="flex items-start gap-4">
                <span className="flex-shrink-0 w-8 h-8 bg-blue-500 text-white rounded-full flex items-center justify-center text-lg font-bold group-hover:scale-110 transition-transform">
                <SvgStart />
                  
                </span>
                <span>Puedes establecer diferentes horarios según tu disponibilidad, y si tienes preferencias, como trabajar solo fines de semana o días laborales.</span>
              </li>
            </ul>
          </div>

          {/* Proceso para Padres */}
          <div
            className="group p-6 bg-white rounded-lg shadow-lg hover:shadow-2xl transition-shadow duration-300"
            onClick={createUserClients}
          >
            <h3 className="text-2xl font-bold text-green-500 mb-4 group-hover:scale-105 transition-transform">
              Para Padres
            </h3>
            <ul className="space-y-4 text-gray-700 text-left">
              <li className="flex items-start gap-4">
                <span className="flex-shrink-0 w-8 h-8 bg-green-500 text-white rounded-full flex items-center justify-center text-lg font-bold group-hover:scale-110 transition-transform">
                <SvgStart />
                  
                </span>
                <span>Proporciona la ubicación donde se llevará a cabo el cuidado de los niños. Esto puede ser en tu hogar o en la casa del niñero.</span>
              </li>
              <li className="flex items-start gap-4">
                <span className="flex-shrink-0 w-8 h-8 bg-green-500 text-white rounded-full flex items-center justify-center text-lg font-bold group-hover:scale-110 transition-transform">
                <SvgStart />
                  
                </span>
                <span>Especifica cuántos niños necesitan cuidado para que la niñera pueda ajustarse a la cantidad de atención requerida.</span>
              </li>
              <li className="flex items-start gap-4">
                <span className="flex-shrink-0 w-8 h-8 bg-green-500 text-white rounded-full flex items-center justify-center text-lg font-bold group-hover:scale-110 transition-transform">
                <SvgStart />
                  
                </span>
                <span>Define también el rango horario en el que necesitas la niñera: ¿es para días específicos o necesitas flexibilidad de horarios?</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
